//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "hub-app-new-or-edit",

	data()
	{
		return {
			app: {},
			appIcon: null,
			notices: [],
			isLoading: false,
			uniqueId: Latte.api.id()
		};
	},

	mounted()
	{
		Latte.action.on("hub:apps:edit", data => this.open(data));
		Latte.action.on("hub:apps:new", data => this.open(data));
	},

	computed: {

		windowTitle()
		{
			if (this.app.id === 0)
				return Latte.i18n.translate("hub-apps", "Create a new app");
			else
				return Latte.i18n.translate("hub-apps", "Edit @0", [this.app.name])
		}

	},

	methods: {

		close()
		{
			this.reset();
			Latte.ui.overlay.close(this.uniqueId);
		},

		open(data)
		{
			this.reset();
			Latte.ui.overlay.open(this.uniqueId);

			if (data.namespace)
				return this.loadApp(data.namespace);
		},

		reset()
		{
			this.app = {
				id: 0,
				logo: null,
				name: "",
				namespace: "",
				android_id: "",
				ios_id: "",
				fcm_server_key: "",
				gsa_auth: "",
				is_active: true,
				users: []
			};
			this.notices = [];
		},

		save()
		{
			this.isLoading = true;
			this.notices = [];

			const body = new FormData();
			const json = JSON.stringify({
				name: this.app.name,
				namespace: this.app.namespace,
				android_id: this.app.android_id,
				ios_id: this.app.ios_id,
				fcm_server_key: this.app.fcm_server_key,
				gsa_auth: this.app.gsa_auth.trim() === "" ? "{}" : this.app.gsa_auth,
				is_active: this.app.is_active,
				users: this.app.users
			});

			if (this.appIcon !== null)
				body.append("files", this.appIcon, this.appIcon.name);

			body.append("json", new Blob([json], {type: "application/json"}));

			const cache = "no-cache";
			const method = this.app.id === 0 ? "PUT" : "PATCH";
			const url = this.app.id === 0 ? "/api/hub/apps" : `/api/hub/apps/${this.app.namespace}`;

			Latte.api.request(url, {body, cache, method})
				.then(r => r.json())
				.then(r => this.onSaveResponse(r))
				.catch(err => Latte.core.handleError(err));
		},

		loadApp(namespace)
		{
			this.isLoading = true;
			Latte.api.request(`/api/hub/apps/${namespace}`, {cache: "no-cache"})
				.then(r => r.json())
				.then(r => this.onAppLoaded(r))
				.catch(err => Latte.core.handleError(err));
		},

		onAppIconSelected(files)
		{
			this.appIcon = files[0];
		},

		onAppLoaded(response)
		{
			this.app = {
				id: response.data.id,
				logo: response.data.logo,
				name: response.data.name,
				namespace: response.data.namespace,
				android_id: response.data.android_id,
				ios_id: response.data.ios_id,
				fcm_server_key: response.data.fcm_server_key,
				gsa_auth: response.data.gsa_auth !== null ? JSON.stringify(response.data.gsa_auth) : "",
				is_active: response.data.is_active,
				users: response.data.users.map(u => u.id)
			};
			this.isLoading = false;
		},

		onSaveResponse(response)
		{
			this.isLoading = false;

			if (response.error)
			{
				this.notices.push({message: response["error_description"], type: "error"});
				return;
			}

			if (response.data && Latte.ui.notice.areEntitiesNotices(response.data))
			{
				for (let notice of response.data)
					this.notices.push({message: notice.message, type: notice.type});

				return;
			}

			Latte.ui.snackbar.create({
				location: Latte.ui.snackbar.Locations.TOP,
				message: Latte.i18n.translate("hub-apps", "App saved successfully!")
			});

			Latte.action.dispatch("data-tables:refresh");

			this.close();

		}

	}

}

